import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../../configs';
import makeRequest from '../../../../utils/makeRequest';
import { deleteBlackWhitesFailed, deleteBlackWhitesSuccessful } from '../../actions';
import { NO_CONTENT } from '../../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../../utils/rejectActionPromise';
import processError from '../../../../utils/processError';

export default function* deleteBlackWhites(action) {
  try {
    const id = action.payload;
    const url = `${BACKEND_URL}/proxy/black-white/v1/blackwhites/${id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteBlackWhitesSuccessful([]));
      yield call(resolveActionPromise(action, {}));
    } else {
      const data = yield dataResponse.json();
      yield put(deleteBlackWhitesFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(deleteBlackWhitesFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
